export const HOME = {
  emergentLink: "emergent-link",
  navBrand: "nav-brand",
  navHamburger: "nav-hamburger",
  navDrawer: "nav-drawer",
  navClose: "nav-close",
  navLinkHome: "nav-link-home",
  navLinkPrograms: "nav-link-programs",
  navLinkAbout: "nav-link-about",
  navLinkReviews: "nav-link-reviews",
  navLinkFaq: "nav-link-faq",
  navLinkNeeds: "nav-link-needs",
  navLinkDashboard: "nav-link-dashboard",
  navLinkAdmin: "nav-link-admin",
  navLoginBtn: "nav-login-btn",
  navLogoutBtn: "nav-logout-btn",
  navRegisterBtn: "nav-register-btn",
  heroBookBtn: "hero-book-free-session-btn",
  navBookBtn: "nav-book-free-session-btn",
  needsBookBtn: "needs-book-free-session-btn",
  stepsBookBtn: "steps-book-free-session-btn",
  finalBookBtn: "final-book-free-session-btn",
  needCard: (i) => `need-card-${i}`,
  areaCard: (i) => `area-card-${i}`,
  programCard: (i) => `program-card-${i}`,
  bookProgramBtn: (i) => `book-program-${i}`,
  faqItem: (i) => `faq-item-${i}`,
  bookingModal: "booking-modal",
  bookingSubmit: "booking-submit",
  bookingDate: "booking-date",
  bookingTime: "booking-time",
  bookingIntention: "booking-intention",
  bookingNotes: "booking-notes",
  loginEmail: "login-email",
  loginPassword: "login-password",
  loginSubmit: "login-submit",
  registerName: "register-name",
  registerEmail: "register-email",
  registerPassword: "register-password",
  registerSubmit: "register-submit",
  dashboardRoot: "client-dashboard",
  inquiryName: "inquiry-name",
  inquiryEmail: "inquiry-email",
  inquiryPhone: "inquiry-phone",
  inquiryIntention: "inquiry-intention",
  inquirySubmit: "inquiry-submit",
};

export const ADMIN = {
  root: "admin-root",
  tabInquiries: "admin-tab-inquiries",
  tabBookings: "admin-tab-bookings",
  filterAll: "admin-filter-all",
  filterNew: "admin-filter-new",
  filterContacted: "admin-filter-contacted",
  filterBooked: "admin-filter-booked",
  filterArchived: "admin-filter-archived",
  search: "admin-search",
  refresh: "admin-refresh",
  inquiryRow: (id) => `admin-inquiry-${id}`,
  inquiryOpen: (id) => `admin-inquiry-open-${id}`,
  inquiryStatus: (id) => `admin-inquiry-status-${id}`,
  inquiryDelete: (id) => `admin-inquiry-delete-${id}`,
  drawerClose: "admin-drawer-close",
  drawerNotes: "admin-drawer-notes",
  drawerSave: "admin-drawer-save",
  bookingRow: (id) => `admin-booking-${id}`,
  bookingStatus: (id) => `admin-booking-status-${id}`,
};
